export default __webpack_public_path__ + "static/media/tabligh.1d1d4ccb.png";